import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { normalizeIdentityValue } from './normalizeIdentityValue';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const deriveResponseAuthorIdentity = (
	storeAssistant: StoreAssistant,
): ResponseAuthorIdentity => {
	const message = storeAssistant.content.message.message;
	const backendAgentId = normalizeIdentityValue(message.agent_author?.id);
	const authorNamedId = normalizeIdentityValue(
		message.author?.external_config_reference ?? message.author?.named_id,
	);

	return {
		id: backendAgentId,
		namedId: authorNamedId,
		isDefault: !backendAgentId && !authorNamedId,
	};
};
